import { DateString } from "./contract/model/ContractViewModel";

export interface CancellationToken {
  isCanceled: boolean;
}

export interface Cancelable<T> extends CancellationToken {
  promise: Promise<T>;
  cancel: () => void;
}

export interface Cancellation {
  isCanceled: true;
}

export function makeCancelable<T>(promise: Promise<T>): Cancelable<T> {
  const context: Partial<Cancelable<T>> = {
    isCanceled: false,
  };

  const wrappedPromise = new Promise<T>((resolve, reject) => {
    promise.then(
      (val) =>
        context.isCanceled ? reject({ isCanceled: true }) : resolve(val),
      (error) =>
        context.isCanceled ? reject({ isCanceled: true }) : reject(error)
    );
  });

  context.promise = wrappedPromise;
  context.cancel = () => (context.isCanceled = true);

  return context as Cancelable<T>;
}

export function capitalize(source?: string) {
  if (!source) return source;

  const str = source.toString();

  return str[0].toUpperCase() + str.slice(1);
}

export function startOfDay(d: DateString | Date) {
  d = new Date(d);
  const result = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0);
  return result;
}

export function addDays(d: DateString | Date, n: number) {
  const result = new Date(d);
  result.setDate(result.getDate() + n);
  return result;
}

export function getRelativeUrlPart(url: URL) {
  return url.pathname + url.search;
}
